import React from "react";

/**
 * Panel for forecast variable inputs (estimated monthly gross, clear button).
 */
const ForecastVariablesPanel = ({
	estimatedMonthlyGross,
	onEstimatedMonthlyGrossChange,
	variableCount,
	onClearVariables,
}) => {
	return (
		<div className="budget-forecast__variables">
			<div className="budget-forecast__variables-header">
				<div className="budget-forecast__variables-title">Forecast Variables</div>
				{variableCount > 0 && (
					<button
						className="budget-forecast__clear-variables"
						onClick={onClearVariables}
					>
						Clear {variableCount} variable{variableCount !== 1 ? "s" : ""}
					</button>
				)}
			</div>
			<div className="budget-forecast__variables-grid">
				<label className="budget-forecast__variable">
					<span className="budget-forecast__variable-label">Est. Monthly Business Gross</span>
					<div className="budget-forecast__variable-input">
						<span className="budget-forecast__variable-prefix">$</span>
						<input
							type="number"
							value={estimatedMonthlyGross}
							onChange={(e) => onEstimatedMonthlyGrossChange(parseFloat(e.target.value) || 0)}
							step="500"
						/>
					</div>
					<span className="budget-forecast__variable-hint">Used for months without invoices</span>
				</label>
			</div>
		</div>
	);
};

export default ForecastVariablesPanel;
